
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { Container } from "inversify";
import CategoryFilterGroup from "../../organization/CategoryFilterGroup.vue";
import InlineFormTreeselect from "../../../../../landing/src/molecules/form/InlineFormTreeselect.vue";
import countries, { ICity, ICountry, IState } from "../../../../../vendor/country-state-city";
import CountryTreeGroup from "../../components/CountryTreeGroup.vue";
import { TreeStructure } from "@gsx/common";

@Component({
    components: {
        CountryTreeGroup,
        InlineFormTreeselect,
        CategoryFilterGroup,
    },
})
export default class CountryFilter extends Vue {
    @Inject("container") readonly container!: Container;
    @Prop() filterStore!: any;
    @Prop({ default: () => [] }) countries!: ICountry[];
    @Prop({ default: () => [] }) states!: IState[];
    @Prop({ default: () => [] }) cities!: ICity[];
    @Prop({ default: true }) forceCountry?: boolean;
    focused = false;

    get CountryObj() {
        return countries;
    }

    get convertedCountries() {
        let convertedCountries = this.countries.slice();
        let unitedStatesIndex = convertedCountries.findIndex((country) => country.id === "231"); // move US to the top
        if (unitedStatesIndex >= 0) {
            let unitedStates = convertedCountries[unitedStatesIndex];
            convertedCountries.splice(unitedStatesIndex, 1);
            convertedCountries.unshift(unitedStates);
        }
        return convertedCountries;
    }

    toggleRegion(regionSet: string[]) {
        this.filterStore.countries = new Set(
            regionSet.filter((region) => region.split(":")[0] === "country"),
        );

        if (this.filterStore.states) {
            this.filterStore.states = new Set(
                regionSet.filter((region) => region.split(":")[0] === "state"),
            );
        }

        if (this.filterStore.cities) {
            this.filterStore.cities = new Set(
                regionSet.filter((region) => region.split(":")[0] === "city"),
            );
        }
    }

    get allFilterSets() {
        let filterSets = Array.from(this.filterStore.countries);

        if (this.filterStore.states) {
            filterSets = filterSets.concat(Array.from(this.filterStore.states));
        }

        if (this.filterStore.cities) {
            filterSets = filterSets.concat(Array.from(this.filterStore.cities));
        }

        return filterSets;
    }

    get countryTreeStructure(): TreeStructure[] {
        let trees: TreeStructure[] = [];

        for (const country of this.convertedCountries) {
            const tree: TreeStructure = {
                id: `country:${country.name}`,
                label: country.name,
            };
            if (this.states && this.states.length) {
                let states: TreeStructure[] = this.states
                    .filter((state) => state.country_id === country.id)
                    .map((state) => ({ id: `state:${state.name}`, label: state.name }));
                tree.children = states.slice();
            } else if (this.cities && this.cities.length) {
                let cities: TreeStructure[] = this.cities
                    .filter(
                        (city) => countries.getStateById(city.state_id).country_id === country.id,
                    )
                    .map((city) => ({ id: `city:${city.name}`, label: city.name }));
                tree.children = cities;
            }
            trees.push(tree);
        }

        return trees;
    }

    get filterCount() {
        let count = 0;
        count += this.getCount(this.filterStore.countries);
        count += this.getCount(this.filterStore.cities);
        count += this.getCount(this.filterStore.states);
        return count;
    }

    getCount(list: Set<any> | undefined) {
        return list ? list.size : 0;
    }

    changeFocus(val: boolean) {
        this.focused = val;
    }
}
